<template>
  <div id="app">
    222
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
  created() {},
};
</script>

<style lang="scss"></style>
